import React from 'react';
import NavigationBar from './NavigationBar';

export default function Layout({ children }) {
    return (
        <div>
            <NavigationBar />
            <div style={{ padding: '20px' }}>
                {children}
            </div>
        </div>
    );
}
